export const metaDataCode = {
    "curl": {
      "request": `curl -X 'GET'
'https://demo-api.westpay.se/in-store/api/v1/metadata'
-H 'accept: text/plain'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'`
    },
    "java": {
      "request": `import java.io.BufferedReader;
import java.io.InputStreamReader;
import java.net.HttpURLConnection;
import java.net.URL;
public class APICallExample {
    public static void main(String[] args) {
        try {
            // Create the URL object with the API endpoint
            URL url = new URL("https://demo-api.westpay.se/in-store/api/v1/metadata");
            // Create the HttpURLConnection object
            HttpURLConnection connection = (HttpURLConnection) url.openConnection();
            connection.setRequestMethod("GET");
            connection.setRequestProperty("accept", "text/plain");
            connection.setRequestProperty("Ocp-Apim-Subscription-Key", "76591d32138f4f60b580db9ec9167f1d");
            // Get the response code
            int responseCode = connection.getResponseCode();
            // If the request was successful (HTTP 200)
            if (responseCode == HttpURLConnection.HTTP_OK) {
                // Read the response
                BufferedReader reader = new BufferedReader(new InputStreamReader(connection.getInputStream()));
                String line;
                StringBuilder response = new StringBuilder();
                while ((line = reader.readLine()) != null) {
                    response.append(line);
                }
                reader.close();
                // Print the response
                System.out.println("Response: " + response.toString());
            } else {
                System.out.println("Error: " + responseCode);
            }
            // Close the connection
            connection.disconnect();
        } catch (Exception e) {
            e.printStackTrace();
        }
    }
}`
    },
    "C#": {
      "request": `using System;
using System.IO;
using System.Net;
class Program
{
    static void Main()
    {
        string url = "https://demo-api.westpay.se/in-store/api/v1/metadata";
        HttpWebRequest request = (HttpWebRequest)WebRequest.Create(url);
        request.Method = "GET";
        request.Headers["accept"] = "text/plain";
        request.Headers["Ocp-Apim-Subscription-Key"] = "76591d32138f4f60b580db9ec9167f1d";
        try
        {
            using (HttpWebResponse response = (HttpWebResponse)request.GetResponse())
            using (Stream responseStream = response.GetResponseStream())
            using (StreamReader reader = new StreamReader(responseStream))
            {
                string responseData = reader.ReadToEnd();
                Console.WriteLine("Response: " + responseData);
            }
        }
        catch (WebException ex)
        {
            if (ex.Response is HttpWebResponse errorResponse)
            {
                Console.WriteLine("Error: " + (int)errorResponse.StatusCode + " " + errorResponse.StatusDescription);
            }
            else
            {
                Console.WriteLine("Error: " + ex.Message);
            }
        }
    }
}`
    },
    "python": {
      "request": `import requests
url = 'https://demo-api.westpay.se/in-store/api/v1/metadata'
headers = {'accept': 'text/plain','Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d'}
try:
    response = requests.get(url, headers=headers)
    response.raise_for_status()  # Raise exception if request was unsuccessful
    # Process the response here
    print(response.text)
except requests.exceptions.RequestException as e:
    # Handle any exception that occurred during the request
    print("An error occurred:", e)`
    },
    
    "JavaScript": {
      "request": `const axios = require('axios');
const url = 'https://demo-api.westpay.se/in-store/api/v1/metadata';
const headers = { 'accept': 'text/plain', 'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d' };
axios.get(url, { headers })
  .then(response => {
    // Process the response here
    console.log(response.data);
  })
  .catch(error => {
    // Handle any error that occurred during the request
    console.error('An error occurred:', error.message);
  });`
    }
  };
  
  export const metaDataCodeResponse = `{
  "errorCodes": [
    {
      "id": 1,
      "code": "WP01",
      "description": "Terminal not linked to a terminal ID"
    },
    {
      "id": 2,
      "code": "WP02",
      "description": "Terminal not found"
    },
    {
      "id": 3,
      "code": "WP03",
      "description": "Merchant inactive"
    },
    {
      "id": 4,
      "code": "WP04",
      "description": "Transaction not found"
    },
    {
      "id": 5,
      "code": "WP05",
      "description": "Unique constraint exception"
    },
    {
      "id": 6,
      "code": "WP06",
      "description": "Reference constraint exception"
    },
    {
      "id": 7,
      "code": "WP07",
      "description": "Cannot insert null exception"
    },
    {
      "id": 8,
      "code": "WP08",
      "description": "Internal server error"
    },
    {
      "id": 9,
      "code": "WP09",
      "description": "Terminal is busy processing another transaction"
    },
    {
      "id": 10,
      "code": "WP10",
      "description": "Unable to generate a unique registration code. Try later! serial no : "
    },
    {
      "id": 11,
      "code": "WP11",
      "description": " Given serial number is already linked to a terminal ID"
    },
    {
      "id": 12,
      "code": "WP12",
      "description": "No terminal found in Unlinked state for given registration code : "
    },
    {
      "id": 13,
      "code": "WP13",
      "description": "No record found for Terminal Id : "
    },
    {
      "id": 14,
      "code": "WP14",
      "description": "No record found for Merchant Id : "
    },
    {
      "id": 15,
      "code": "WP15",
      "description": "Merchant not active : "
    },
    {
      "id": 16,
      "code": "WP16",
      "description": "Specified terminal does not belong to the merchant"
    },
    {
      "id": 17,
      "code": "None",
      "description": "None"
    },
    {
      "id": 18,
      "code": "WP18",
      "description": "No transaction is processing currently in the specified terminal"
    },
    {
      "id": 19,
      "code": "WP19",
      "description": "Error while generating JWT Token"
    },
    {
      "id": 20,
      "code": "WP20",
      "description": "MerchantID cannot be null or empty"
    },
    {
      "id": 21,
      "code": "WP21",
      "description": "TerminalID cannot be null or empty"
    },
    {
      "id": 22,
      "code": "WP22",
      "description": "PaymentMethod recieved from ECR is invalid"
    },
    {
      "id": 23,
      "code": "WP23",
      "description": "No SignalR connection found for the terminal"
    },
    {
      "id": 24,
      "code": "WP24",
      "description": "Failed sending SignalR notification to terminal"
    },
    {
      "id": 25,
      "code": "WP25",
      "description": "Acknowledgement timed-out from terminal"
    },
    {
      "id": 26,
      "code": "WP26",
      "description": "Only 30 days of data is allowed to retrieve"
    },
    {
      "id": 27,
      "code": "WP27",
      "description": "Only past 90 days data is availble to retrieve"
    },
    {
      "id": 28,
      "code": "WP28",
      "description": "Database concurrency issue"
    },
    {
      "id": 29,
      "code": "WP29",
      "description": "One or more required fields missing"
    },
    {
      "id": 30,
      "code": "WP30",
      "description": "Terminal has acknowledged the previous transaction, but it has not send a response. Hence user may cancel the previous transaction if its timed-out"
    },
    {
      "id": 31,
      "code": "WP31",
      "description": "Transaction is not in a valid state"
    },
    {
      "id": 32,
      "code": "WP32",
      "description": "Token validity period should be greater than 0"
    },
    {
      "id": 33,
      "code": "WP33",
      "description": "Terminal is already linked to a serial number"
    },
    {
      "id": 34,
      "code": "WP34",
      "description": "No print request found with Id"
    },
    {
      "id": 35,
      "code": "WP35",
      "description": "No print support available for the terminal"
    }
    ],
    "transactionStatuses": [
    {
      "id": 0,
      "code": "APPROVED",
      "description": "APPROVED"
    },
    {
      "id": 1,
      "code": "ABORTED_BY_CARDHOLDER",
      "description": "ABORTED_BY_CARDHOLDER"
    },
    {
      "id": 2,
      "code": "ABORTED_BY_CASHIER",
      "description": "ABORTED_BY_CASHIER"
    },
    {
      "id": 3,
      "code": "TERMINAL_IS_BUSY",
      "description": "TERMINAL_IS_BUSY"
    },
    {
      "id": 4,
      "code": "CARD_HAS_EXPIRED",
      "description": "CARD_HAS_EXPIRED"
    },
    {
      "id": 5,
      "code": "INVALID_CARD",
      "description": "INVALID_CARD"
    },
    {
      "id": 6,
      "code": "CARD_IS_BLOCKED",
      "description": "CARD_IS_BLOCKED"
    },
    {
      "id": 7,
      "code": "OFFLINE_QUEUE_IS_FULL",
      "description": "OFFLINE_QUEUE_IS_FULL"
    },
    {
      "id": 8,
      "code": "TECHNICAL_ERROR",
      "description": "TECHNICAL_ERROR"
    },
    {
      "id": 9,
      "code": "TERMINAL_IS_OFFLINE",
      "description": "TERMINAL_IS_OFFLINE"
    },
    {
      "id": 10,
      "code": "TERMINAL_MUST_UPDATE",
      "description": "TERMINAL_MUST_UPDATE"
    },
    {
      "id": 11,
      "code": "TRANSACTION_DECLINED",
      "description": "TRANSACTION_DECLINED"
    },
    {
      "id": 12,
      "code": "WRONG_PIN",
      "description": "WRONG_PIN"
    },
    {
      "id": 13,
      "code": "REVERSED",
      "description": "REVERSED"
    },
    {
      "id": 14,
      "code": "PENDING",
      "description": "PENDING"
    }
    ],
    "paymentMethods": [
    {
      "id": 0,
      "code": "Swish",
      "description": "Swish"
    },
    {
      "id": 1,
      "code": "Klarna",
      "description": "Klarna"
    },
    {
      "id": 2,
      "code": "Vipps",
      "description": "Vipps"
    }
    ]
    }`;
